import { FC } from 'react';

import { Image, Typography } from 'antd';

import { ActionButton, ActionButtonProps } from '@hdi-seguros/web-components.action-button';

import { ColSize } from '../ColSize';
import { RowSize } from '../RowSize';

import { QuotationDoneIcon } from '../../../assets';

import { COLORS } from '../../../config/themes/colors';

import './index.css';

interface ConfirmationProp {
  title?: string;
  description?: string;
  secondaryButtonConfirm?: ActionButtonProps;
  showButtonConfirm?: boolean;
  onPressConfirm?: () => void;
  onPressSecondary?: () => void;
}

export const Confirmation: FC<ConfirmationProp> = ({ title, description, onPressConfirm, onPressSecondary, secondaryButtonConfirm,showButtonConfirm=true }) => {

  return (
    <RowSize
      rowProps={{
        justify: 'center',
        align: 'middle',
      }}
      className='confirmation-container-row'
    >
      <ColSize
        size={100}
        className='confirmation-container-col'
      >
        <Image
          src={QuotationDoneIcon}
          width={250}
          height={200}
          preview={false}
        />
      </ColSize>

      <ColSize
        size={description ? 100: 25}
        className='confirmation-container-col'
      >
        <Typography.Title level={3} style={{ color: COLORS.neutrals[80], margin: 0}}>
          {title}
        </Typography.Title>
      </ColSize>

      {
        description && (
          <ColSize
            size={25}
            className='confirmation-container-col'
          >
            <Typography.Text type='secondary' className='confirmation-text'>
              {description}
            </Typography.Text>
          </ColSize>
        )
      }

      <ColSize
        size={100}
        className='confirmation-container-col'
      >
        {
          secondaryButtonConfirm && (
            <ActionButton
              {...secondaryButtonConfirm}
              className={`btn-principal-outline-barbuss  action-button-confirmation ${secondaryButtonConfirm?.className ?? ''}`}
              onClick={onPressSecondary}
              type={secondaryButtonConfirm.type ?? 'secondary'}
            />
          )
        }
        {showButtonConfirm && <ActionButton
          label='Aceptar'
          className='btn-principal-barbuss action-button-confirmation'
          onClick={onPressConfirm}
        />}

      </ColSize>
    </RowSize>
  );
};
